<template>
  <div class="d-activity-single">
    <div v-if="activity">
      <DActivityEntry
        :class="{ 'visible-until-sm': activity.isEditing }"
        :activity="activity"
        :num-displayed-replies-on-comments="5"
        :user-avatar-url="userAvatarUrl"
        :user-name="userName"
        :user-slug="userSlug"
        :user-url="userUrl"
        @activity-removed="activityRemoved"
      />

      <DPostForm
        v-if="activity.isEditing"
        :activity="activity"
        :is-author="isAuthor"
        :user-avatar-url="userAvatarUrl"
        @post-edited="postEdited"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import DActivityEntry from '@d-components/d-activity-feed/d-activity-entry/d-activity-entry.vue';
import DPostForm from '@d-components/d-activity-feed/d-post-form/d-post-form.vue';
import { getErrorMessage } from '@d-shared/utils/errors';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

export default {
  components: {
    DActivityEntry,
    DPostForm,
  },
  props: {
    isAuthor: {
      type: Boolean,
      default: false,
    },
    userAvatarUrl: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
    userSlug: {
      type: String,
      required: true,
    },
    userUrl: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    activity: null,
  }),
  mounted() {
    this.loadActivityInfo();
  },
  methods: {
    activityRemoved() {
      Window.goTo(URLS.app.feed);
    },

    loadActivityInfo() {
      const activityInfoEl = document.getElementById('activity-info');
      if (!activityInfoEl) {
        Vue.duiNotificationManager.error(getErrorMessage(null));
        return;
      }

      try {
        const activity = JSON.parse(activityInfoEl.dataset.activity);
        activityInfoEl.remove();
        this.$set(this, 'activity', activity);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },

    postEdited(editedPost) {
      this.$set(this, 'activity', editedPost);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-activity-single {
  @include screenLessThan(md) {
    margin: 0 (-$_2em);
  }

  .d-activity-entry {
    margin: 0;
  }
}
</style>
